var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import { mediaQueries } from 'Theme';
import { FieldCheckbox, FieldDate, FieldTime, FieldImage, FieldInput, FieldSelect, FieldTextArea, } from 'elements';
import FieldIcon from './FieldIcon';
import theme from 'Theme';
import FieldLabel from './FieldLabel';
import FieldToggleSelect from './FieldToggleSelect';
import { PricingTierEditor } from '../components/PricingTier';
var Field = /** @class */ (function (_super) {
    __extends(Field, _super);
    function Field() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*componentDidMount() {
      const lib = (window as any).PricingTierLib_BS
      if (lib) {
        // ya estaba cargado
        this.setState({ PricingTierEditor: lib.PricingTierEditor })
      } else {
        const script = document.createElement('script')
        script.src = '/assets/js/pricing-tier-lib-bs.umd.cjs'
        script.onload = () => {
          const loadedLib = (window as any).PricingTierLib_BS
          if (loadedLib) {
            this.setState({ PricingTierEditor: loadedLib.PricingTierEditor })
          }
        }
        document.head.appendChild(script)
      }
    }*/
    Field.prototype.renderField = function () {
        var _a = this.props, field = _a.field, reactstrap = _a.reactstrap, onChange = _a.onChange, onSavePrice = _a.onSavePrice;
        var value = field.value || '';
        // console.log('Field - render - field: ', field)
        // console.log('Field - render - field.value: ', field.value)
        // console.log('Field - render - field.type: ', field.type)
        // console.log('Field - render - field.tooltipId: ', field.tooltipId)
        // console.log('Field - render - field.tooltip: ', field.tooltip)
        var required = (field.rules && field.rules.isRequired) || false;
        switch (field.type) {
            case 'price': {
                // const {PricingTierEditor} = this.state
                // console.log('PricingTierEditor: ', PricingTierEditor)
                if (!PricingTierEditor)
                    return null;
                var initialTiers = void 0;
                if (value && Array.isArray(value)) {
                    initialTiers = __spreadArray([], value, true);
                }
                else {
                    initialTiers = [
                        { id: (value && value.id) || undefined, minPax: 1, maxPax: null, price: value || '', enabled: true, passengerCategory_id: field.passengerCategory_id },
                    ];
                }
                var money_id = value[0];
                return (React.createElement(PricingTierEditor, { categoryLabel: field.column || field.name, currency: "USD", initialTiers: initialTiers, passengerCategory_id: field.passengerCategory_id, 
                    // money_id={field.money_id}
                    onChange: function (newTiers) {
                        // this.setState({tiers: newTiers})
                        // onChange(field.name, newTiers, field.column)
                    }, onSave: function (newTiers, passengerCategory_id) {
                        // const passengerCategory_id = (value[0] || value as Price)?.passengerCategory_id || newTiers[0]?.passengerCategory_id
                        var tiersTosend = newTiers.map(function (_a) {
                            var id = _a.id, tier = __rest(_a, ["id"]);
                            return (__assign(__assign({}, tier), (id > 0 ? { id: id } : {}) // solo incluir id si es positivo (real de BD)
                            ));
                        });
                        onSavePrice(tiersTosend, passengerCategory_id);
                    } }));
            }
            case FieldType.Text:
            case FieldType.Number:
            case FieldType.Password:
                return (React.createElement(FieldInput, { id: field.tooltipId, tooltipContent: field.tooltip, type: field.type, name: field.name, column: field.column, value: value, required: required, reactstrap: reactstrap, onChange: onChange, disabled: field.disabled }));
            case FieldType.TextArea:
                return (React.createElement(FieldTextArea, { id: field.tooltipId, tooltipContent: field.tooltip, type: field.type, name: field.name, column: field.column, value: value, required: required, onChange: onChange }));
            case FieldType.Checkbox:
                return (React.createElement(FieldCheckbox, { id: field.tooltipId, tooltipContent: field.tooltip, type: field.type, name: field.name, column: field.column, value: value, required: required, onChange: onChange }));
            case FieldType.Image:
                return (React.createElement(FieldImage, { id: field.tooltipId, tooltipContent: field.tooltip, name: field.name, column: field.column, value: value, footer: field.footer, accept: field.accept, onChange: onChange }));
            case FieldType.Select:
                return field.options ? (React.createElement(FieldSelect, { id: field.tooltipId, tooltipContent: field.tooltip, name: field.name, column: field.column, value: value, options: field.options, placeholder: field.placeholder, required: required, onChange: onChange })) : null;
            case FieldType.MultiSelect:
                return field.options ? (React.createElement(FieldSelect, { id: field.tooltipId, tooltipContent: field.tooltip, multiple: true, name: field.name, column: field.column, value: value, options: field.options, placeholder: field.placeholder, required: required, onChange: onChange })) : null;
            case FieldType.ToggleSelect:
                return field.options ? (React.createElement(FieldToggleSelect, { id: field.tooltipId, tooltipContent: field.tooltip, multiple: field.multiple, name: field.name, column: field.column, value: value, options: field.options, placeholder: field.placeholder, required: required, onChange: onChange, 
                    // content={field.content}
                    onError: field.onError })) : null;
            case FieldType.Date:
                return (React.createElement(FieldDate, { name: field.name, mode: field.mode, opened: field.opened, column: field.column, date: field.value, required: required, startDay: field.startDay, endDay: field.endDay, onChange: onChange, disabled: field.disabled }));
            case FieldType.DateTime:
                return (React.createElement(FieldDate, { name: field.name, column: field.column, date: value, withTime: true, required: required, onChange: onChange }));
            case FieldType.Time:
                return (React.createElement(FieldTime, { name: field.name, column: field.column, hora: value, required: required, onChange: onChange }));
            case FieldType.Icon:
                return (React.createElement(FieldIcon, { icon: value, icons: field.icons, onChange: onChange }));
            case FieldType.Label:
                return (React.createElement(FieldLabel, { type: field.type, name: field.name, column: field.column, value: value, required: required, underline: field.underline, onChange: onChange }));
            default:
                return null;
        }
    };
    Field.prototype.render = function () {
        var _a = this.props, field = _a.field, reactstrap = _a.reactstrap;
        return React.createElement(Wrapper, { size: !reactstrap && field.size }, this.renderField());
    };
    return Field;
}(Component));
export default Field;
export var FieldType = {
    Checkbox: 'checkbox',
    Date: 'date',
    DateTime: 'dateTime',
    Time: 'time',
    Icon: 'icon',
    Image: 'image',
    Number: 'number',
    Password: 'password',
    Select: 'select',
    Text: 'text',
    Label: 'label',
    TextArea: 'textarea',
    MultiSelect: 'multiSelect',
    ToggleSelect: 'toggleSelect',
};
var Wrapper = cxs('div')(function (_a) {
    var _b;
    var size = _a.size;
    return (_b = {
            padding: '0.1px'
        },
        _b[mediaQueries.desktop] = {
            display: 'flex',
            flex: "1 1 ".concat((size || 10) * 10, "%"),
            alignItems: 'flex-end',
            '> div': {
                flex: 1
            }
        },
        _b);
});
Wrapper.propTypes = {
    size: PropTypes.number
};
var propsToolTip = {
    // eventOn: 'onMouseOver',
    eventOff: 'onClick',
    hoverDelay: 800,
    background: theme.color.secondary,
    color: 'white',
    mouseOutDelay: 100,
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/Field.tsx
// module id = 394
// module chunks = 0